import getBindedLocalSelectors from "utils/getBindedLocalSelectors";
import getSelectors, { getVal } from "utils/getSelectors";
import local from "./local";

export default function selectorsGen(storeShape = { app: ["app"] }) {
  const appStorePath = storeShape.app;

  const local$ = getBindedLocalSelectors(local, appStorePath);

  const basicSelectors = getSelectors({
    stateRestored$$: [local$.stateRestored, getVal],
    permissionsClarified$$: [local$.permissionsClarified, getVal],
    cacheRestored$$: [local$.cacheRestored, getVal],
  });

  return {
    ...basicSelectors,
  };
}



// WEBPACK FOOTER //
// ./src/model/subsystems/app/selectors/selectors.js